import { SBCRewardType } from "@/api/privateRequests/sbcs/getSbcSets";
import SBCToggle from "@/components/organisms/SBCs/SBCToggle/SBCToggle";
import { convertSBCPrice } from "@/functions/convertPlayerPrice";
import { extractRewardUrl } from "@/functions/extractRewardUrl";
import {
  Tier,
  playerRoleLabelSelector,
  tierSelector,
} from "@/redux/players/playersSlice";
import { BREAKPOINTS } from "@/settings";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "usehooks-ts";

import SBCDesktop from "./views/SBCDesktop";
import SBCMobile from "./views/SBCMobile";

type Props = {
  name: string;
  imageURL: string;
  reward: SBCRewardType;
  requirements: string[];
  price: number;
  platform: "Playstation" | "PC";
  onComplete: (completed: boolean) => void;
  reqHeightDifference: number;
  disableComplete?: boolean;
  isCompleted?: boolean;
  description?: string;
  isOnSolutionsPage?: boolean;
  disableToggle: boolean;
};

const SBC = ({
  name,
  imageURL,
  reward,
  requirements: requirementsInput,
  price,
  platform,
  onComplete,
  reqHeightDifference,
  disableComplete,
  isCompleted = false,
  description,
  isOnSolutionsPage,
  disableToggle,
}: Props) => {
  const [hovered, setHovered] = useState(false);
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);

  const playerRole = useSelector(
    playerRoleLabelSelector({
      playerRoleId: reward?.metaRating?.playerRoleId,
    }),
  );
  const tier: Tier = useSelector(
    tierSelector(
      reward?.metaRating?.metarating || 0,
      reward?.metaRating?.playerRoleId,
    ),
  );

  const safeReqHeight =
    Number.isFinite(reqHeightDifference) && reqHeightDifference > 0
      ? Math.floor(reqHeightDifference)
      : 0;
  const requirements = [
    ...requirementsInput,
    ...Array(safeReqHeight).fill("-"),
  ];

  const formattedPrice = convertSBCPrice(price);
  const rewardUrl = extractRewardUrl(reward);

  const toggleState = hovered ? "hovered" : isCompleted ? "active" : "";
  const sbcToggle = (
    <SBCToggle
      disableToggle={disableToggle}
      disabled={disableComplete}
      onMouseEnter={() => !isMobile && setHovered(true)}
      onMouseLeave={() => !isMobile && setHovered(false)}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onComplete(!isCompleted);
      }}
      type="completed"
      state={toggleState}
    />
  );

  const viewProps = {
    name,
    imageURL,
    reward,
    rewardUrl,
    playerRole,
    tier,
    description,
    requirements,
    formattedPrice,
    sbcToggle,
    platform,
    isOnSolutionsPage,
  };

  return isMobile ? (
    <SBCMobile {...viewProps} />
  ) : (
    <SBCDesktop {...viewProps} />
  );
};

export default SBC;
